//jshint esversion:6
import '../styles/ProjectText.css';

function ProjectText() {
  return (
    <div className='container-fluid project-text'>
      <h1 className='pl2'>Projects</h1>
    </div>
  );
}

export default ProjectText;
